import { Box } from '@material-ui/core';
import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { useFormState } from 'react-final-form';
import FormOptionsTable from '../../components/FormOptionsTable/FormOptionsTable';
import { useShopConfig } from '../../hooks/shopConfig';
import { FIND_ITEM_METHOD_TO_TAB } from './EditListingPage.utils';
import { FieldRadioButton, NamedLink, TypographyWrapper } from '../../components';
import { EditListingPageState } from './EditListingPage.duck';
import { useEnabledCustomerExperiences } from '../../hooks/useEnabledCustomerExperiences';
import { FIND_ITEM_METHOD } from '../../components/Shopify/Shopify.utils';
import { TypographyWeight } from '../../components/TypographyWrapper/TypographyWrapper';
import { FindItemMethod } from '../../types/sharetribe/listing';

const ItemFromBrand: FC = () => {
  const {
    images: { shopLogo },
    shopName,
  } = useShopConfig();
  return (
    <TypographyWrapper
      variant="body1"
      weight={TypographyWeight.Bold}
      typographyOverrides={{ style: { display: 'flex', alignItems: 'baseline' } }}
    >
      An item from
      <img style={{ marginLeft: '8px', height: '1em' }} src={shopLogo.url} alt={shopName} />
    </TypographyWrapper>
  );
};

const AnyItem: FC = () => (
  <TypographyWrapper variant="body1" weight={TypographyWeight.Bold}>
    An item from another brand
  </TypographyWrapper>
);

const showSearchAsSelected = Object.values(FindItemMethod).filter(
  (method) => method !== FindItemMethod.ListAnyBrand
);

const LIST_ANYTHING_CONFIG = {
  [FindItemMethod.Search]: {
    label: <ItemFromBrand />,
    showAsSelected: showSearchAsSelected,
  },
  [FindItemMethod.ListAnyBrand]: {
    label: <AnyItem />,
    showAsSelected: [FindItemMethod.ListAnyBrand],
  },
};
const ListAnyBrandToggle: FC = () => {
  const { values } = useFormState();
  const { params } = useSelector<any>((state) => state.EditListingPage) as EditListingPageState;
  const { isListSellOnly, isListTradeInOnly, allowTradeInAndMarketplace } =
    useEnabledCustomerExperiences();
  return (
    <>
      <TypographyWrapper variant="h1" typographyOverrides={{ style: { marginBottom: '10px' } }}>
        <>
          {isListTradeInOnly && 'What are you trading in?'}
          {isListSellOnly && 'What are you selling?'}
          {allowTradeInAndMarketplace && 'What are you selling or trading in?'}
        </>
      </TypographyWrapper>
      <Box mb={3}>
        <FormOptionsTable containerId={FIND_ITEM_METHOD}>
          {Object.entries(LIST_ANYTHING_CONFIG).map(([findItemMethodValue, config]) => {
            const nextTab = FIND_ITEM_METHOD_TO_TAB[findItemMethodValue as FindItemMethod];
            return (
              <NamedLink
                key={`${findItemMethodValue}-link}`}
                name="EditListingPage"
                params={{
                  ...params,
                  tab: nextTab,
                }}
              >
                <Box py={1}>
                  <FieldRadioButton
                    key={findItemMethodValue}
                    showAsRequired
                    id={`${FIND_ITEM_METHOD}-${findItemMethodValue}`}
                    name={FIND_ITEM_METHOD}
                    label={config.label}
                    value={findItemMethodValue}
                    checked={config.showAsSelected.includes(values[FIND_ITEM_METHOD])}
                  />
                </Box>
              </NamedLink>
            );
          })}
        </FormOptionsTable>
      </Box>
    </>
  );
};

export default ListAnyBrandToggle;
